import { BaseModel, BaseModelKeys } from '../base.model';
import { MappingProperty } from '../functions';

export enum LogMessageTypes {
  login = 'LOGIN',
  registration = 'REGISTRATION',
  otpValidation = 'OTP_VALIDATION_ISSUE',
  mergeIssue = 'MERGE_ISSUE',
}

export enum LogMessageSourceTypes {
  system = 'system',
  uid = 'uid',
  email = 'email',
  agentDbId = 'agentDbId',
}

export enum LogMessageKeys {
  type = 'type',
  sourceType = 'source_type',
  source = 'source',
  message = 'message',
  errorCode = 'error_code',
  archived = 'archived',
  payload = 'data',
  notes = 'notes',
}
export class LogMessage extends BaseModel {
  [LogMessageKeys.type]: LogMessageTypes;
  [LogMessageKeys.sourceType]: LogMessageSourceTypes;
  [LogMessageKeys.source]: string;
  [LogMessageKeys.message]: string;
  [LogMessageKeys.errorCode] = this.generateErrorCode();
  [LogMessageKeys.archived] = false;
  [LogMessageKeys.payload]: string = null;
  [LogMessageKeys.notes]?: string = null;

  constructor(
    type: LogMessageTypes,
    sourceType: LogMessageSourceTypes,
    source: string,
    message: string,
    payload?: any,
  ) {
    super();

    this[LogMessageKeys.type] = type;
    this[LogMessageKeys.source] = source;
    this[LogMessageKeys.sourceType] = sourceType;
    this[LogMessageKeys.message] = message;
    this[LogMessageKeys.payload] = payload;
  }

  private generateErrorCode(): string {
    return 'xxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

export const LogMessageMapping: {
  [key: string]: MappingProperty;
} = {
  [LogMessageKeys.type]: { type: 'keyword' },
  [LogMessageKeys.source]: { type: 'keyword' },
  [LogMessageKeys.sourceType]: { type: 'keyword' },
  [LogMessageKeys.message]: { type: 'keyword' },
  [LogMessageKeys.errorCode]: { type: 'keyword' },
  [LogMessageKeys.payload]: { type: 'flattened' },
  [LogMessageKeys.archived]: { type: 'boolean' },
  [BaseModelKeys.createdDate]: { type: 'date' },
  [BaseModelKeys.createdBy]: { type: 'keyword' },
  [BaseModelKeys.createdByAgentDbId]: { type: 'keyword' },
  [BaseModelKeys.createdByEmail]: { type: 'keyword' },
};
